import React from 'react';
import Section from './Section';
import FirstRunHero from '../../components/dashboard/empty/FirstRunHero';
import JourneyPreview from '../../components/dashboard/empty/JourneyPreview';
import ExplainerVideo from '../../components/dashboard/empty/ExplainerVideo';

/**
 * /design gallery — the zero-RFQ dashboard. Compare with
 * `Dashboard - Empty State.html`. Rendered from the presentational halves so
 * the gallery never creates an RFQ; the live page wires the same pieces to
 * `useFirstRfqUpload`. The rejected-file error is shown here because it is
 * otherwise only reachable by dropping something unreadable.
 */
const FirstRunGallery: React.FC = () => (
  <Section title="Dashboard — first run (zero RFQs)">
    <div className="mx-auto flex w-full max-w-[900px] flex-col gap-[16px]">
      <FirstRunHero firstName="Priya" />
      <JourneyPreview />
      <ExplainerVideo />
      <p className="text-meta text-ink-muted">With a video configured</p>
      <ExplainerVideo src="/walkthrough.mp4" duration="2 min" />
      <p className="text-meta text-ink-muted">Drag-over and rejected-file states</p>
      <FirstRunHero firstName="Priya" isDragActive />
      <FirstRunHero
        firstName="Priya"
       
        error="I can't read notes.key — I work with Excel, CSV, PDF, Word, plain text, images and ZIP folders."
      />
    </div>
  </Section>
);

export default FirstRunGallery;
